import ShipOptionsForm from 'components/Checkout/Sections/ShipOptions/ShipOptionsForm/ShipOptionsForm';
import { withSplitEDDProps } from 'viewModel/sharedComponents/splitEDD/withSplitEDDProps';

export default withSplitEDDProps(ShipOptionsForm);
